import React from "react";
import SiteLayout from "../components/SiteLayout";
import { SERVICES, PACKAGES } from "../data/staticData";
import PackageCards from "../components/PackageCards";
import PricingDRGrid from "../components/PricingDRGrid";
import { Link } from "react-router-dom";
import CTASection from "../components/sections/CTASection";

export default function Pricing() {
  return (
    <SiteLayout>
      <section className="pt-20 pb-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="eyebrow mb-4">Pricing</div>
          <h1 className="font-display text-5xl sm:text-6xl font-bold tracking-tight max-w-3xl">
            Transparent. Productized. No "request a quote" walls.
          </h1>
          <p className="mt-6 text-inkSoft text-lg max-w-2xl">Every service ships at fixed prices with fixed scope — from a single link building placement to a full digital PR campaign. Bulk discounts available at the agency tier — talk to us.</p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="mb-8">
            <div className="eyebrow mb-3">Guest posting</div>
            <h2 className="font-display text-3xl font-bold tracking-tight">Tiered by Domain Rating (DR)</h2>
            <p className="text-inkSoft mt-2 text-sm max-w-xl">All tiers include original content, manual outreach, and niche-relevant placements.</p>
          </div>
          <PricingDRGrid />
        </div>
      </section>

      {SERVICES.filter((s) => s.slug !== "guest-posting").map((s) => (
        <section key={s.slug} className="py-12" data-testid={`pricing-section-${s.slug}`}>
          <div className="max-w-7xl mx-auto px-6 lg:px-8">
            <div className="flex items-end justify-between gap-4 mb-8">
              <div>
                <div className="eyebrow mb-3">{s.title}</div>
                <h2 className="font-display text-3xl font-bold tracking-tight">{s.short}</h2>
              </div>
              <Link to={`/services/${s.slug}`} className="text-sm text-terra font-medium hover:underline whitespace-nowrap">Learn more →</Link>
            </div>
            <PackageCards serviceSlug={s.slug} packages={PACKAGES[s.slug] || []} />
          </div>
        </section>
      ))}

      <CTASection />
    </SiteLayout>
  );
}
